import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useServerApi } from "../hooks/userServerApi";
import { Text, Group, Select, Button } from "@mantine/core";
import moment from "moment";
import { DatePicker } from "@mantine/dates";
import { openFileUrl } from "../utils/openReport";

const ReportAIRequest = () => {
  const [years, setYears] = useState([]);
  const [loading, setLoading] = useState(false);
  const today = moment().startOf("day").toDate();
  const [fromDate, setFromDate] = useState(today);
  const [toDate, setToDate] = useState(today);
  const { t } = useTranslation();
  const [api] = useServerApi();

  const downloadReport = async () => {
    try {
      setLoading(true);
      const result = await api.AIRequest.getReport(fromDate, toDate);
      console.log(result);
      if (result && result.data && result.data.url) {
        await openFileUrl(result.data.url);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };
  return (
    <div>
      <Text size="xs">{t("Please select the year of AI Request")}</Text>
      <Group mt="xs">
        <DatePicker
          title="From"
          size="xs"
          allowFreeInput
          placeholder="From"
          value={fromDate}
          onChange={(d) => setFromDate(d)}
        />
        -
        <DatePicker
          title="To"
          size="xs"
          allowFreeInput
          placeholder="To"
          value={toDate}
          onChange={(d) => setToDate(d)}
        />
      </Group>
      <Button size="xs" mt="xl" onClick={() => downloadReport()}>
        {t("Download")}
      </Button>
    </div>
  );
};

export default ReportAIRequest;
